import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import Formatters from '../../../shared/utils/Formatters';

const propTypes = {
  unlockDate: PropTypes.string.isRequired,
  redirectTo: PropTypes.func.isRequired,
  url:        PropTypes.string.isRequired,
};

const UnlockSoon = ({ unlockDate, redirectTo, url }) => {

  function formattedUnlockDate() {
    if (isNil(unlockDate)) return null;

    return Formatters.date(unlockDate);
  }

  const onClick = () => redirectTo(url);

  return (
    <section className='cardSection _textAlign_center' data-testid='unlock-soon-component'>
      <h2 className='subhead -darkBlue'>Submit your invoices and purchase orders
        <br />
        for pre-approval
      </h2>

      <p className='copy -secondary' data-testid='unlock-soon-copy'>
        If you pay on time your upcoming payments&nbsp;
        <br className='_displayNone-mobileOnly' />
        until <strong className=''>{formattedUnlockDate()}</strong>, you can take another&nbsp;
        <br className='_displayNone-mobileOnly' />
        loan again after that date.
      </p>
      <button className='ds-btn _margin--auto --small' data-testid='submit-preapproval-btn' data-path='/apply-now' onClick={onClick}>
        Submit for pre-approval
      </button>
    </section>
  );
}

UnlockSoon.propTypes = propTypes;
export default UnlockSoon;



// WEBPACK FOOTER //
// ./src/features/CreditLimit/components/utilization/UnlockSoon.js